import React, { useRef } from "react"
import { Modal, Typography, Space, Button, message } from "@mimber/ui-web"
import { useDeleteCommunicationTemplate } from "@mimber/client/mimber-organization"
import type { DeleteCommunicationTemplateModalProps } from "./DeleteCommunicationTemplateModal.types"

const { Text, Paragraph } = Typography

export const DeleteCommunicationTemplateModal: React.FunctionComponent<
  DeleteCommunicationTemplateModalProps
> = ({ template, onSuccess, ...modalProps }) => {
  const closeRef = useRef<(() => void) | null>(null)

  const mutation = useDeleteCommunicationTemplate(template.uuid, {
    onSuccess: () => {
      message.success("Template deleted successfully")
      closeRef.current?.()
      onSuccess?.()
    },
    onError: (error) => {
      message.error(`Failed to delete template: ${error.message}`)
    },
  })

  return (
    <Modal title="Delete Template" footer={null} {...modalProps}>
      {(close) => {
        closeRef.current = close
        return (
          <Space orientation="vertical" size="large" style={{ width: "100%" }}>
            <Paragraph>
              Are you sure you want to delete the template{" "}
              <Text strong>"{template.name}"</Text>?
            </Paragraph>
            <Paragraph type="secondary">
              This action cannot be undone. Any announcements referencing this
              template will lose the link.
            </Paragraph>
            <Space style={{ justifyContent: "flex-end", width: "100%" }}>
              <Button onClick={close} disabled={mutation.isPending}>
                Cancel
              </Button>
              <Button
                type="primary"
                danger
                loading={mutation.isPending}
                onClick={() => mutation.mutate()}
              >
                Delete Template
              </Button>
            </Space>
          </Space>
        )
      }}
    </Modal>
  )
}
